import React, { useState } from 'react';
import '../style/package.css';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight, FaCheck } from 'react-icons/fa';

const PackagesSection = () => {
    const [activePackage, setActivePackage] = useState(0);
    const navigate = useNavigate();

    const packagesData = [
        {
            id: 1,
            title: "VFX Signature",
            mainDescription: "Perfect for car features or brand visuals",
            subPackages: [
                {
                    name: "VFX-style hero video",
                    description: "Dynamic 20-45 second video for attention-grabbing content",
                    features: ["Advanced Transitions", "Sound Design", "Creative Editing"]
                },
                {
                    name: "Cinematic reel",
                    description: "Relaxed artistic portrayal with cinematic quality",
                    features: ["Color Grading", "Slow Motion", "Ambient Sound"]
                },
                {
                    name: "Full photo set",
                    description: "Professional photographs for marketing and social media",
                    features: ["High-Resolution", "Retouching", "Multiple Angles"]
                }
            ]
        },
        {
            id: 2,
            title: "Event Coverage",
            mainDescription: "Multi-day event coverage with cinematic recap",
            subPackages: [
                {
                    name: "Multi-day coverage",
                    description: "Complete coverage over 2-3 day events",
                    features: ["Full Coverage", "Story-driven", "Highlights"]
                },
                {
                    name: "Cinematic recap",
                    description: "Professional recap with VFX-enhanced reels",
                    features: ["Cinematic Quality", "VFX Integration", "Social-ready"]
                }
            ]
        },
        {
            id: 3,
            title: "Ad Content",
            mainDescription: "High-impact social media ads with animations",
            subPackages: [
                {
                    name: "Short-form videos",
                    description: "Ten high-impact videos for social engagement",
                    features: ["Social Optimized", "High-Impact", "Brand Focused"]
                },
                {
                    name: "Animated visuals",
                    description: "Eye-catching animations for better engagement",
                    features: ["Motion Graphics", "2D/3D Elements", "Custom Animation"]
                }
            ]
        },
        {
            id: 4,
            title: "Creator Plan",
            mainDescription: "Monthly content strategy and planning",
            subPackages: [
                {
                    name: "Creative strategy",
                    description: "Continuous support for fresh content",
                    features: ["Content Planning", "Trend Analysis", "Brand Alignment"]
                }
            ]
        },
        {
            id: 5,
            title: "Real Estate",
            mainDescription: "Cinematic property showcases with VFX",
            subPackages: [
                {
                    name: "VFX property reel",
                    description: "Dynamic reel with visual effects for listings",
                    features: ["Fast Paced", "Visual Effects", "Social Ready"]
                },
                {
                    name: "Showcase video",
                    description: "Beautiful video tour highlighting features",
                    features: ["Cinematic Quality", "Full Tour"]
                }
            ]
        },
        {
            id: 6,
            title: "Educational",
            mainDescription: "Monthly short-form videos for creators",
            subPackages: [
                {
                    name: "Monthly videos",
                    description: "10-15 engaging short-form videos",
                    features: ["Monthly Deliverables", "Social Optimized", "Quick Edits"]
                },
                {
                    name: "Enhanced editing",
                    description: "Captions, SFX and animated elements",
                    features: ["Dynamic Captions", "Sound Effects", "Motion Graphics"]
                }
            ]
        }
    ];

      const handleContactClick = () => {
        navigate('/contact');
    };

    return (
        <section className="fx-packages-section">
            {/* Animated Header Section */}
            <div className="fx-packages-header">
                <div className="fx-header-background">
                    <div className="fx-laser-ray fx-ray-1"></div>
                    <div className="fx-laser-ray fx-ray-2"></div>
                    <div className="fx-laser-ray fx-ray-3"></div>
                    <div className="fx-laser-ray fx-ray-4"></div>
                    <div className="fx-laser-ray fx-ray-5"></div>
                    <div className="fx-laser-ray fx-ray-6"></div>
                    <div className="fx-laser-ray fx-ray-7"></div>
                    <div className="fx-laser-ray fx-ray-8"></div>
                    <div className="fx-grid-pattern"></div>
                    <div className="fx-pulse-effect"></div>
                </div>
                <div className="fx-header-content">
                    <h2 className="fx-packages-title">Our Packages</h2>
                    <p className="fx-packages-subtitle">Choose the perfect plan for your visual needs</p>
                </div>
            </div>

            <div className="fx-packages-container">
                {/* Package Tabs - Single Row with Only Names */}
                <div className="fx-package-tabs-single-row">
                    {packagesData.map((pkg, index) => (
                        <button
                            key={pkg.id}
                            className={`fx-package-tab-simple ${index === activePackage ? 'active' : ''}`}
                            onClick={() => setActivePackage(index)}
                        >
                            {pkg.title}
                        </button>
                    ))}
                </div>

                {/* Package Details */}
                <div className="fx-package-details">
                    <div className="fx-package-main">
                        <div className="fx-package-header">
                            <h3 className="fx-package-main-title">
                                {packagesData[activePackage].title} Package
                            </h3>
                            <p className="fx-package-main-desc">
                                {packagesData[activePackage].mainDescription}
                            </p>
                            <button className="fx-book-now-btn" onClick={handleContactClick}>
                                Book Now <FaArrowRight />
                            </button>
                        </div>
                    </div>

                    <div className="fx-sub-packages-grid">
                        {packagesData[activePackage].subPackages.map((subPkg, index) => (
                            <div key={index} className="fx-sub-package">
                                <h4 className="fx-sub-package-title">{subPkg.name}</h4>
                                <p className="fx-sub-package-desc">{subPkg.description}</p>
                                <div className="fx-sub-package-features">
                                    {subPkg.features.map((feature, idx) => (
                                        <div key={idx} className="fx-feature-item">
                                            <FaCheck className="fx-feature-icon" />
                                            <span>{feature}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PackagesSection;